import React from 'react';
import { Box, Typography } from '@mui/material';

/** Blocks landscape on phones/tablets — portrait-only per AS_BlogM1. */
export default function LandscapePortraitLock() {
    return (
        <Box
            className="landscape-portrait-lock"
            sx={{
                display: 'none',
                '@media (max-width: 1024px) and (orientation: landscape)': {
                    display: 'flex',
                },
                position: 'fixed',
                inset: 0,
                zIndex: 99999,
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#1a1a2e',
                color: '#fff',
                px: 3,
                textAlign: 'center',
            }}
            role="dialog"
            aria-label="Rotate device to portrait"
        >
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                Please rotate your device
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9, maxWidth: 320 }}>
                SafeVault works best in portrait mode. Turn your phone upright to continue.
            </Typography>
        </Box>
    );
}
